module.exports = __webpack_public_path__ + "img/3bbf4f1.png";